module.exports = __webpack_public_path__ + "static/media/upcomming_listing_empty.c6d73944.png";